/** @jsx jsx */

import { Fragment as _, useMemo, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Image from 'components/lib/Image';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext as InteractionContext } from './interactionContext';
import Sortation from './Sortation_v3';
import SortationHeading from './SortationHeading';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from 'factories/block';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import Video from 'components/lib/Video';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import Media_default from 'assets/Short Rectangle.svg';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Audio from 'components/lib/Audio';
import { SortableImage } from './SortableImage';
import { imgPlaceholders } from 'components/lib/Image';
import longRectangle from 'assets/Long Rectangle.svg';

const Components = {
  Row,
  Column,
  Text: EditableText,
  SortationQuestionText: ({ children, ...props }) => children,
  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;
    const { isAdditionalMedia } = mediaContext;

    return (
      <Image
        {...{
          ...props,
          placeholder: !isAdditionalMedia
            ? Media_default
            : longRectangle || imgPlaceholders[1],

          usePlaceholderValue: true,
        }}
      />
    );
  },
  Video,
  Transcript,
  SVG,
  Embed,
  Media,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: () => null,
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [sortation, txt] = children;

    if (!includeAdditionalTextField) {
      return sortation;
    }

    return (
      <_>
        {sortation}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },
  Sortation: ({ children, ...props }) => {
    return <Sortation {...{ children, ...props }} />;
  },
  SortationHeading0: SortationHeading,
  SortationHeading1: SortationHeading,
  SortableImage,
  Answer: () => null,
  Feedback: ({ children }) => children,
  Correct: () => null,
  Incorrect: () => null,
  Attempt: () => null,
  PDF,
  OpenPDF,
  Audio,
  Modal: () => null,
};

const SortationDisplay = (props) => {
  const interactionBlock = getBlockById(props.blockId);

  const hasAttemptFeedback = findByKeyVal_V2(
    interactionBlock.id,
    'type',
    'Attempt'
  );

  const container = (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{
          ...interactionBlock,
          updateItemsSeen: null,
          hasAttemptFeedback,
        }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );

  return window.dev()
    ? container
    : useMemo(() => {
        return container;
      }, [props.isOpen, interactionBlock.props!.lockDown]);
};

export default SortationDisplay;
